import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Badge
} from "reactstrap";
import CoursePostulation from "../course/Postulation";
import classnames from "classnames";
import ApplicantUserProfile from "./UserProfile";
import ApplicantPostulations from "./ApplicantPostulations";
import ApplicantDocuments from "./ApplicantDocuments";
import MatchDetail from "./MatchDetail";
import Notifications from "../commons/Notifications";

const ApplicantShow = ({ applicant, isAdmin, course, currentUserRole }) => {
  const notifications = useRef(null);
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const showNotification = (title, message, type) => {
    notifications.current.addNotifications(title, message, type);
  };

  return (
    <Row
      className={`profile-full`}
    >
      <Notifications ref={notifications} />
      <Col lg="12">
        <Card className="mb-4 profile-full-card">
          <CardBody>
            <Row>
              <Col lg="6">
                <Nav pills className="nav-justified navigation-icons-tabs h-100 align-items-center">
                  <NavItem className="text-center small">
                    <NavLink
                      className={"p-2 " + classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggleTab("1");
                      }}
                    >
                      <i aria-hidden="true" className="fas fa-user d-block fa-3x mb-2"></i>
                      Perfil Usuario
                    </NavLink>
                  </NavItem>
                  <NavItem className="text-center small">
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggleTab("2");
                      }}
                    >
                      <i className="fas fa-suitcase d-block fa-3x mb-2"></i>
                      Postulaciones Asociadas
                    </NavLink>
                  </NavItem>
                  <NavItem className="text-center small">
                    <NavLink className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                      toggleTab("3");
                    }}
                    >
                      <i className="far fa-file-alt d-block fa-3x mb-2"></i>
                      Documentos Cargados
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col lg="12">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <ApplicantUserProfile
              applicant={applicant}
              showNotification={showNotification}
              isAdmin={isAdmin}
              currentUserRole={currentUserRole}
            />
          </TabPane>
          <TabPane tabId="2">
            <ApplicantPostulations
              postulations={applicant.postulations || []}
              isAdmin={isAdmin}
              currentUserRole={currentUserRole}
            />
          </TabPane>
          <TabPane tabId="3">
            <ApplicantDocuments applicant={applicant} />
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  );
};

export default ApplicantShow;
